import { COOKIE_KEYS, sessionStorageKeys } from 'constants/common'
import Cookies from 'js-cookie'

type LoginSuccessInfo = {
  showSuccessModal: string
  googleSSOLogin: string
}

type BookingDetailsParam = {
  selectedSlot: SelectedSlot
  providerDetails: Provider
  appointmentModeId?: string
  counselingTypeId?: string
  loginSuccessInfo?: LoginSuccessInfo
  bookingAttribution?: BookingAttribution
  salesforceDetails?: SalesforceDetails
  /** Analytics origin tag, e.g. `blind_booking`. */
  slotLocation?: string
  /** Kept for the V2 funnel, which drops the bookings query string. */
  selfPay?: boolean
}

export const storeBookingDetailsForV2 = ({
  selectedSlot,
  providerDetails,
  appointmentModeId,
  counselingTypeId,
  loginSuccessInfo,
  bookingAttribution,
  salesforceDetails,
  slotLocation,
  selfPay,
}: BookingDetailsParam): void => {
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem(
      `persist:${sessionStorageKeys.BOOKING_PERSIST_KEY}`
    )
  }

  Cookies.set(COOKIE_KEYS.PRE_BOOKING_SELECTION, {
    slot: {
      id: selectedSlot.slot.id,
      start: selectedSlot.slot.start,
      end: selectedSlot.slot.end,
      availabilityType: selectedSlot.slot.availabilityType,
    },
    providerId: providerDetails.id,
    practiceId: providerDetails.practice.id,
    ...(appointmentModeId ? { appointmentModeId } : null),
    ...(counselingTypeId ? { counselingTypeId } : null),
    ...(loginSuccessInfo ? { loginSuccessInfo } : null),
    ...(bookingAttribution ? { bookingAttribution } : null),
    ...(salesforceDetails ? { salesforceDetails } : null),
    ...(slotLocation ? { slotLocation } : null),
    ...(selfPay ? { selfPay: true } : null),
  })
}

export const getAddressFromRP = (
  patientAddress: PatientAddress | null | undefined
): PatientAddress => {
  return patientAddress
    ? {
        line1: patientAddress.line1 || '',
        line2: patientAddress.line2 || '',
        city: patientAddress.city || '',
        state: patientAddress.state || '',
        zipcode: patientAddress.zipcode || '',
      }
    : {
        line1: '',
        line2: '',
        city: '',
        state: '',
        zipcode: '',
      }
}

// Helper function to check if responsible party info is complete

export const isResponsiblePartyInfoComplete = (userData: User): boolean => {
  if (userData) {
    // Check if user data has all required fields for creating self patient
    return !!(
      userData.firstName &&
      userData.lastName &&
      userData.responsiblePartyEhrId &&
      userData.address?.line1 &&
      userData.dob
    )
  }
}
